import React, { useState, useEffect } from 'react';
import { Alert, Collapse, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import type { PageIndex, TabIndex, ModalIndex, SectionIndex } from '@/common/i-doc/i-doc.registry.ts';
import { useUiSettings } from '@/contexts/UiSettingsContext';

export type IDocKey = PageIndex | TabIndex | ModalIndex | SectionIndex;

interface PageHintProps {
  iDoc: IDocKey;
}

export const PageHint: React.FC<PageHintProps> = ({ iDoc }) => {
  const { hintsEnabled, hintsResetKey } = useUiSettings();
  const { t } = useTranslation('hints');
  const text = t(iDoc.replace(/:/g, '.'), { defaultValue: '' });
  const lsKey = `page-hint-dismissed:${iDoc}`;
  const [visible, setVisible] = useState(() => localStorage.getItem(lsKey) !== 'true');

  useEffect(() => {
    setVisible(localStorage.getItem(lsKey) !== 'true');
  }, [hintsResetKey, lsKey]);

  if (!hintsEnabled || !text || !visible) return null;

  const handleDismiss = () => {
    localStorage.setItem(lsKey, 'true');
    setVisible(false);
  };

  return (
    <Collapse in unmountOnExit>
      <Alert
        severity="info"
        sx={{ mb: 3 }}
        action={
          <IconButton size="small" onClick={handleDismiss}>
            <Close fontSize="inherit" />
          </IconButton>
        }
      >
        {text}
      </Alert>
    </Collapse>
  );
};
